import {needAuth} from "../instance/Instance";

async function getDailyCheckList(search, pageable) {
    console.log(">> 일일체크코드 코드 List 조회")

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {
            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    try{
        return  await needAuth.post(`/settings/report/dailyCheck?`+pageStr,search);
    }catch (error){
        return error;
    }
}

async function selectAllDailyCheck(search, pageable) {
    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {
            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    return await needAuth.post(`/settings/report/dailyCheck/list?`+pageStr,search);
}

async function removeDailyChecks(ids) {
    return await needAuth.put('/settings/report/dailyCheck/delete', ids);
}

async function getDailyCheck(id) {
    return await needAuth.get('/settings/report/dailyCheck/'+id);
}

async function saveDailyCheck(data) {
    return await needAuth.post(`/settings/report/dailyCheck/create`, data);
}

async function updateDailyCheck(data) {
    return await needAuth.post(`/settings/report/dailyCheck/update`, data);
}

export {
    getDailyCheckList,
    removeDailyChecks,
    saveDailyCheck,
    getDailyCheck,
    updateDailyCheck,
    selectAllDailyCheck
}